import React, { useEffect, useMemo, useState } from "react";
import { Modal, Table, Spinner, Form } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CustomButton from "../../components/CustomButton";
import { LINEAR_GRADIENT_BG, SHOP_SETTING_KEY } from "../../const";
import { GET_SUVIVALS } from "../../apollo/unit/Query";
import { useLazyQuery } from "@apollo/client";
// import { FormatNumber } from "../../helper";

export default function PurchaseModal({
  SetshowOrderModal,
  showOrderModal,
  cartDatas,
  setCartDatas,
  updateOrder,
  createPurchaseorderLoading,
  onClearOrder,
  onCreateManyPurchaseOrderWithPurchaseOrderDetail,
}) {
  // Queries and state
  const [getSurvival, { loading: loadingSurvival, data: survivalData }] = useLazyQuery(GET_SUVIVALS, { fetchPolicy: "cache-first" });
  const [searchLot, setSearchLot] = useState({});
  
  // Memoized values
  const lots = useMemo(() => {
    const lotsData = survivalData?.survivals?.data || [];
    return lotsData;
  }, [survivalData]);
  const shopSetting = useMemo(() => JSON.parse(localStorage.getItem(SHOP_SETTING_KEY)) || {}, []);

  // Fetch survival data on component mount
  useEffect(() => {
    const controller = new AbortController();
    
    const fetchSurvivalData = async () => {
      try {
        const userData = localStorage.getItem("SHOP_DATA");
        const locals = JSON.parse(userData);
        if (!locals) return;
        
        await getSurvival({
          variables: {
            where: {
              shop: locals?.id || "",
              status: true,
              isDeleted: false
            },
          },
          context: { fetchOptions: { signal: controller.signal } },
        });
        
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error fetching survival data:', error);
        }
      }
    };

    // Call immediately
    fetchSurvivalData();
    
    return () => controller.abort();
  }, [getSurvival]); // Remove loadingSurvival from dependencies
  
  // Handle product field updates
  const handleEditProduct = (e, cIndex, index, fieldName) => {
    try {
      if (!cartDatas || !e.target || !fieldName) return;
      
      const newProduct = [...cartDatas];
      const targetOrder = newProduct[cIndex]?.data?.orders[index];
      
      if (!targetOrder) return;
      
      targetOrder[fieldName] = e.target.value;
      setCartDatas(newProduct);
    } catch (error) {
      console.error(`Error updating ${fieldName}:`, error);
    }
  }
  
  // Handle shipping cost updates
  const handleEditShippingCost = (e, cIndex, index) => {
    try {
      const newProduct = [...cartDatas];
      const targetOrder = newProduct[cIndex]?.data?.orders[index];
      
      if (!targetOrder) return;
      
      const shippingCost = e?.target?.value.replace(",", "");
      targetOrder.shippingCost = parseInt(shippingCost || 0, 10);
      
      setCartDatas(newProduct);
    } catch (error) {
      console.error('Error updating shipping cost:', error);
    }
  }
  
  // Helper function to render quantity adjustment controls
  const renderQuantityControls = (order, cIndex, oIndex) => (
    <div className="d-flex align-items-center gap-1">
      <CustomButton
        onClick={() => {
          if (order?.amount <= 1) return onClearOrder(order);
          updateOrder({
            product: order,
            productId: order?.product,
            isAdded: false,
            changeValue: 0,
          });
        }}
        icon={<RemoveIcon />}
        width="36px"
        height="36px"
        background="#6B7280"
        borderRadius="5px"
      />
      <Form.Control
        type="number"
        className="mx-1 text-center"
        style={{ width: "70px" }}
        min="0"
        value={order?.amount}
        onChange={(e) => {
          updateOrder({
            product: order,
            productId: order?.product,
            isAdded: true,
            changeValue: parseInt(e?.target?.value || 0),
          });
        }}
      />
      <CustomButton
        onClick={() =>
          updateOrder({
            product: order,
            productId: order?.product,
            isAdded: true,
            changeValue: 0,
          })
        }
        icon={<AddIcon />}
        width="36px"
        height="36px"
        background="#6B7280"
        borderRadius="5px"
      />
    </div>
  );

  return (
    <Modal
      show={showOrderModal }
      onHide={() => SetshowOrderModal(false)}
      size="xl"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton className="py-2">
        <div className="d-flex w-100 align-items-center">
          <div className="w-50">
            <Modal.Title>ລາຍການສິນຄ້າ</Modal.Title>
          </div>
          <div className="w-50 ps-2">
            <Form.Select
              className="form-select py-2"
              style={{ color: "#6B7280", cursor: "pointer" }}
              onChange={(e) => {
                console.log("Available lots:", lots);
                const selectedLot = lots?.find(lot => lot?.id === e.target.value);
                console.log("Selected lot:", selectedLot);
                setSearchLot(selectedLot);
                let newProduct = [...cartDatas];
                newProduct[0].lot = e.target.value;
                setCartDatas(newProduct);
              }}
            >
              {loadingSurvival ? (
                <option>Loading...</option>
              ) : (
                <>
                  <option key={0} value="ALL">ລ໊ອດທັງໝົດ</option>
                  {lots?.map((lot, index) => (
                    <option key={index+1} value={lot?.id}>
                      {lot?.survivalNumber}
                    </option>
                  ))}
                </>
              )}
            </Form.Select>
          </div>
        </div>
      </Modal.Header>
      
      <Modal.Body className="p-2">
        <div className="table-responsive">
          <Table hover className="w-100" style={{ borderRadius: "8px" }}>
            <thead style={{ background: LINEAR_GRADIENT_BG, borderRadius: "8px 8px 0 0", color: "#FFFFFF" }}>
              <tr>
                <th className="py-2">ລ/ດ</th>
                <th className="py-2">ລ໊ອດ</th>
                <th className="py-2">ຊື່</th>
                <th className="py-2">ປະເພດ</th>
                <th className="py-2">ແບຣນ</th>
                {shopSetting?.stockInOut && <th className="py-2">ຜະລີດ</th>}
                {shopSetting?.stockInOut && <th className="py-2">ຫມົດອາຍຸ</th>}
                <th className="py-2">ຈ/ນທີ່ເພີ່ມ</th>
                <th className="py-2">ຈັດການ</th>
              </tr>
            </thead>
            <tbody>
              {cartDatas?.map((cart, cIndex) =>
                cart?.data?.orders?.map((order, oIndex) => (
                  <tr key={`order-${oIndex}`}>
                    <td className="py-2">{oIndex + 1}</td>
                    <td className="py-2">{searchLot?.survivalNumber ?? '...'}</td>
                    <td className="py-2">{order?.productName}</td>
                    <td className="py-2">{order?.category || "-"}</td>
                    <td className="py-2">{order?.brand || "-"}</td>
                    {shopSetting?.stockInOut && (
                      <td className="py-2">
                        <Form.Control
                          type="date"
                          value={order?.mfg}
                          onChange={(e) => handleEditProduct(e, cIndex, oIndex, "mfg")}
                          style={{ width: "130px" }}
                        />
                      </td>
                    )}
                    {shopSetting?.stockInOut && (
                      <td className="py-2">
                        <Form.Control
                          type="date"
                          value={order?.exp}
                          onChange={(e) => handleEditProduct(e, cIndex, oIndex, "exp")}
                          style={{ width: "130px" }}
                        />
                      </td>
                    )}
                    <td className="py-2">
                      {renderQuantityControls(order, cIndex, oIndex)}
                    </td>
                    <td className="py-2 text-center">
                      <CustomButton
                        onClick={() => onClearOrder(order)}
                        title="ລົບ"
                        width="50px"
                        height="36px"
                        background="#dc3545"
                        borderRadius="5px"
                        color="#fff"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="d-flex justify-content-end py-2">
        <div style={{ marginRight: "1em" }}>
          <CustomButton
            width={130}
            height={38}
            borderRadius={4}
            background="transparent"
            color="#3C169B"
            border="1px solid #3C169B"
            fontweight={400}
            title="ຍົກເລີກ"
            disabled={createPurchaseorderLoading}
            onClick={() => SetshowOrderModal(false)}
          />
        </div>
        <CustomButton
          disabled={createPurchaseorderLoading}
          className="ms-3"
          width={130}
          height={38}
          background={LINEAR_GRADIENT_BG}
          borderRadius={4}
          title={createPurchaseorderLoading ? <Spinner animation="border" size="sm" /> : "ຢືນຢັນ"}
          onClick={onCreateManyPurchaseOrderWithPurchaseOrderDetail}
        />
      </Modal.Footer>
    </Modal>
  );
}
